import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@store/utils';

export interface State {
  code: string;
  name: string;
  available: boolean;
}
export interface County {
  fips: number;
  name: string;
  available: boolean;
}
export interface City {
  code: number;
  name: string;
  available: boolean;
}
export const usTerritoriesApi = createApi({
  reducerPath: 'usTerritories',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getStates: builder.query<any, any>({
      query: () => ({
        url: `states/`,
      }),
    }),
    getCountiesByState: builder.query<any, any>({
      query: (stateAbbr: string) => ({
        url: `counties/?state=${stateAbbr}`,
      }),
    }),
    getCitiesByCountyFips: builder.query<any, any>({
      query: (countyFips: string) => ({
        url: `cities/?county=${countyFips}`,
      }),
    }),
    getAddress: builder.query<any, any>({
      query: (zip: string) => ({
        url: `address_info/?zip_code=${zip}`,
      }),
    }),
  }),
});

export const {
  useGetStatesQuery,
  useLazyGetCountiesByStateQuery,
  useLazyGetCitiesByCountyFipsQuery,
  useLazyGetAddressQuery,
} = usTerritoriesApi;
